<span class="text-center free-shipping">
  {{customText}}
</span>
